export default __webpack_public_path__ + "static/media/logo-white.89992421.png";